import { render, staticRenderFns } from "./AppLink.vue?vue&type=template&id=091f801e&"
import script from "./AppLink.vue?vue&type=script&lang=ts&"
export * from "./AppLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports